import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';
import type { HotelProposalItem } from '../../../types/proposalBundles';
import HotelItemRow from './HotelItemRow';

interface Props {
  items: HotelProposalItem[];
  includeTax: boolean;
  bundleStayDays: number | null;
  priceHeaderNote: string;
  disabled: boolean;
  onSelect: (itemId: number) => void;
  onOpenDetail: (itemId: number) => void;
  isSpLayout?: boolean;
}

const HotelItemsTable = ({
  items,
  includeTax,
  bundleStayDays,
  priceHeaderNote,
  disabled,
  onSelect,
  onOpenDetail,
  isSpLayout = false
}: Props) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  if (isSpLayout) {
    return (
      <div style={styles.spList}>
        {items.map((item, index) => (
          <HotelItemRow
            key={item.id}
            item={item}
            index={index}
            includeTax={includeTax}
            stayDays={bundleStayDays}
            disabled={disabled}
            onSelect={onSelect}
            onOpenDetail={onOpenDetail}
            isSpLayout
          />
        ))}
      </div>
    );
  }

  return (
    <table style={styles.table}>
      <thead>
        <tr style={styles.tableHeaderRow}>
          <th style={styles.tableHeaderCellName}>ホテル名</th>
          <th style={styles.tableHeaderCellDetail}>情報</th>
          <th style={styles.tableHeaderCellAmenity}>朝食・タバコ</th>
          <th style={styles.tableHeaderCellStay}>泊数</th>
          <th style={styles.tableHeaderCellPrice}>
            料金<span style={styles.priceUnitNote}>{priceHeaderNote}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, index) => (
          <HotelItemRow
            key={item.id}
            item={item}
            index={index}
            includeTax={includeTax}
            stayDays={bundleStayDays}
            disabled={disabled}
            onSelect={onSelect}
            onOpenDetail={onOpenDetail}
          />
        ))}
      </tbody>
    </table>
  );
};

export default HotelItemsTable;

const getStyles = (theme: AITTheme) => ({
  table: {
    width: '100%',
    borderCollapse: 'collapse' as const
  },
  tableHeaderRow: {
    backgroundColor: '#f5f5f5',
    borderBottom: '2px solid #ececec'
  },
  tableHeaderCellName: {
    padding: '10px',
    textAlign: 'center' as const,
    fontSize: '13px',
    width: '32%'
  },
  tableHeaderCellDetail: {
    padding: '10px',
    textAlign: 'center' as const,
    fontSize: '13px',
    width: '12%'
  },
  tableHeaderCellAmenity: {
    padding: '10px',
    textAlign: 'center' as const,
    fontSize: '13px',
    width: '15%'
  },
  tableHeaderCellStay: {
    padding: '10px',
    textAlign: 'center' as const,
    fontSize: '13px',
    width: '13%'
  },
  tableHeaderCellPrice: {
    padding: '10px',
    textAlign: 'center' as const,
    fontSize: '13px',
    width: '28%'
  },
  priceUnitNote: {
    marginLeft: '4px',
    fontSize: '11px',
    color: theme.linkColor
  },
  spList: {
    display: 'flex',
    flexDirection: 'column' as const
  }
});
